import { pdf } from '@react-pdf/renderer';
import { auth } from '../firebase';
import PDFDeclaration from './PDFDeclaration';
import { countries, countriesHashMap } from '../countries';
import { ComEmpleo, ComExencionTasa, DecRespAutorizaciones, DecRespAutorizacionesNinguna, DecResponsableAprovechamiento } from './PDFTemplates';
import { getCase, getFirestoreDoc, setCase } from '../firestore';
import { ResponsibleDeclaration } from './ResponsibleDeclaration';
import { getFile } from '../googleCloudStorage';
import { useEffect, useState } from 'react';

export const declarations = {
	noInternationalProtection: "126.a: Que me encuentro en España, no tengo la condición de solicitante de protección internacional en el momento de la presentación de mi solicitud y no solicitaré protección internacional durante la tramitación de la presente solicitud.",
	inSpainMinTime: "126.b: Que he permanecido en territorio español de forma continuada durante, al menos, los dos años anteriores a la presentación de esta solicitud, sin contar, en su caso, tiempo de permanencia como solicitante de protección internacional.",
	notBased: "126.c: Que no represento una amenaza para el orden, seguridad o salud pública.",
	noAntecedentes: "126.d: Que carezco de antecedentes penales en España y en los países donde haya residido durante los cinco últimos años anteriores a la fecha de mi entrada en España, por delitos previstos en el Código Penal español.",
	segundaOportunitadadNoAmenaza: "127.a.1: Que he sido titular de una autorización de residencia, que no fue otorgada por circunstancias excepcionales, en los dos años inmediatamente anteriores a la fecha de la presentación de mi solicitud, y cuya renovación no se produjo por motivos distintos a razones de orden, seguridad o salud pública.",
	segundaOportunidadAmenaza: "127.a.2: Que he sido titular de una autorización de residencia, que no fue otorgada por circunstancias excepcionales, en los dos años inmediatamente anteriores a la fecha de la presentación de mi solicitud, cuya renovación no se produjo por motivos de orden, seguridad o salud pública, si bien existe sentencia denegatoria, sobreseimiento o absolución de la pena.",
	noAntecedentes2: "130.1.2.1: Que el artículo 130.1.2 del Real Decreto 1155/2024, de 19 de noviembre, por el que se aprueba el Reglamento de la Ley Orgánica 4/2000, de 11 de enero, sobre derechos y libertades de los extranjeros en España y su integración social me exime de presentar certificado de antecedentes penales toda vez que he permanecido de forma continuada en España durante los últimos cinco años inmediatamente anteriores a la fecha de presentación de la presente solicitud.",
	yaHePresentadoAntecedentes: "130.1.2.2: Que el artículo 130.1.2 del Real Decreto 1155/2024, de 19 de noviembre, por el que se aprueba el Reglamento de la Ley Orgánica 4/2000, de 11 de enero, sobre derechos y libertades de los extranjeros en España y su integración social me exime de presentar certificado de antecedentes penales toda vez que aporté certificado de antecedentes penales en una solicitud anterior, formulada dentro de los cinco años inmediatamente anteriores a la presente solicitud, sin que me haya ausentado desde entonces del territorio español.",
}

export function DummyPDFGen() {
	const [pdf, setPdf] = useState(null)

	useEffect(() => {
		(async () => {
			const caseUUID = "xdB8hpr75MZxRzj2hAktf"
			const curCase = await getCase(caseUUID)
			const signatureImg = await getFile("4tQYIMYkoOs4P45fEh3RA", true)
			const declaration = declarations.notBased
			const pdfBlob = await MyPDFDownloadLink(curCase, ResponsibleDeclaration, signatureImg, declaration)
			setPdf(pdfBlob)
		})()
	}, [])

	if (!pdf) return <p>Loading PDF…</p>
	return <iframe src={URL.createObjectURL(pdf)} width="100%" height="800px" />
}


const generatePdfBlob = async (props, whichPDF, signatureImg, declaration=null) => {
	const blob = await pdf(whichPDF(props, signatureImg, declaration)).toBlob();
	return blob;
};

const downloadPdf = async (props, whichPDF, signatureImg, declaration=null) => {
	const blob = await generatePdfBlob(props, whichPDF, signatureImg, declaration);
	const url = URL.createObjectURL(blob);
	return blob;
// 	const link = document.createElement('a');
// 	link.href = url;
// 	link.download = 'document.pdf';
// 	document.body.appendChild(link);
// 	link.click();
// 	document.body.removeChild(link);
};

export async function MyPDFDownloadLink(curCase, whichPDF, signatureImg, declaration=null) {
	const basicInfo = curCase.basicInfo;
	const address = curCase.address;
	let props = {}
	props.fullName = basicInfo.firstName;
	props.fullName += basicInfo.middleName ? ` ${basicInfo.middleName}` : '';
	props.fullName += basicInfo.lastName ? ` ${basicInfo.lastName}` : '';
	props.fullName += basicInfo.secondLastName ? ` ${basicInfo.secondLastName}` : '';


// 	props.province = curCase.province.value;
	props.province = "Madrid";
	props.province2 = "Madrid";
	//This has to be translated to Spanish...
	const citizenship1 = basicInfo.countriesOfCitizenship[0].value;
	props.citizenship1 = countriesHashMap.es[citizenship1];

	props.passport = basicInfo.passportNumber;
	props.nie = basicInfo.NIE;
	props.numJobs = curCase.numJobs;

	props.address = ''
	props.address += address.typeOfStreet.label ? `${address.typeOfStreet.label}` : '';
	props.address += ` ${address.street}, ${address.streetNumber}`;
	props.address += address.apt ? `, ${address.apt}` : '';
	props.address += `, ${address.postalCode}`;
	props.address += ` ${address.city}`
	props.address += ` ${address.province.label}`;
	//We need a separate field for this because one of Roberto's genius templates specifically has this datum alone. Fucking lawyers.
	props.postalCode = address.postalCode;
	//Ditto
	props.city = address.city

	props.municipality = address.city;
	props.date = new Date().toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric' });

	if (whichPDF === ResponsibleDeclaration) {
		console.log("RESPONSIBLE DECLARATION", declaration)
		const blob = await downloadPdf(props, whichPDF, signatureImg, declaration);
		return blob;
	}
	else {
		const blob = await downloadPdf(props, whichPDF, signatureImg);
		return blob;
	}
}
	
